module.exports = __webpack_public_path__ + "img/33.5a0e523f.png";